import React, { useState, useEffect, useRef } from 'react';
import { User, ChevronDown, LogOut } from 'lucide-react';

interface HeaderProps {
  currentPage: string;
  user: {
    role: 'paciente' | 'nutricionista';
    name: string;
    email: string;
    avatar?: string;
  };
  onLogout: () => void;
  onRefresh?: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentPage, user, onLogout, onRefresh }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getPageTitle = () => {
    switch (currentPage) {
      case 'pacientes':
        return '';
      case 'agendamento':
        return '';
      case 'avaliacao':
        return 'Avaliações';
      case 'relatorios':
        return 'Relatórios';
      default:
        return '';
    }
  };

  return (
    <header className="header bg-white border-bottom shadow-sm p-3">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-title">
            <h4 className="mb-0 text-dark">{getPageTitle()}</h4>
          </div>
          
          <div className="flex-grow-1 d-flex justify-content-center d-md-none">
            <img 
              src="/logo3.png" 
              alt="Logo" 
              className="mobile-logo"
              style={{height: '95px', width: 'auto', objectFit: 'contain'}}
            />
          </div>
          
          <div className="position-relative" ref={dropdownRef}>
            <button 
              type="button"
              className="user-card d-flex align-items-center gap-2 bg-light p-2 rounded border"
              onClick={() => setShowDropdown(!showDropdown)}
              style={{cursor: 'pointer', border: 'none'}}
            >
              <div className="user-avatar d-flex align-items-center justify-content-center bg-success text-white rounded-circle" style={{width: '32px', height: '32px'}}>
                {user.avatar ? (
                  <img 
                    src={user.avatar} 
                    alt={user.name}
                    className="rounded-circle"
                    style={{width: '32px', height: '32px', objectFit: 'cover'}}
                  />
                ) : (
                  <User size={18} />
                )}
              </div>
              <div className="user-info">
                <div className="user-name fw-semibold text-dark" style={{fontSize: '0.8rem'}}>{user.name}</div>
                <div className="user-email text-muted" style={{fontSize: '0.7rem'}}>{user.email}</div>
              </div>
              <ChevronDown 
                size={16} 
                className="text-muted" 
                style={{
                  transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease'
                }} 
              />
            </button>
            
            {showDropdown && (
              <div className="dropdown-menu show position-absolute end-0 mt-1 shadow border" style={{minWidth: '160px', zIndex: 1050}}>
                <button 
                  className="dropdown-item d-flex align-items-center gap-2 py-2 px-3 text-start"
                  style={{fontSize: '0.8rem'}}
                  onClick={() => {
                    setShowDropdown(false);
                    onLogout();
                  }}
                >
                  <LogOut size={14} />
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;